import { Component, AfterViewInit, OnInit, OnDestroy, HostListener, ElementRef, TemplateRef, Input } from '@angular/core';

import * as State from '@shared/state';

@Component({
    selector: 'shared-modal-box',
    templateUrl: './modal-box.shared.component.html',
    styleUrls: ['./modal-box.shared.component.scss']
})
export class ModalBoxComponent implements AfterViewInit, OnInit, OnDestroy {
    @Input() public positionVerticalOffset!: 'minus' | 'plus';
    @Input() public modalData: State.IModal;
    @Input() public size: OLO.Components.MODAL_SIZE;
    @Input() public mobilePreserve: boolean = false;
    @Input() public top: TemplateRef<any>;
    @Input() public minHeight: number = 0;

    @HostListener('click', ['$event']) public onBoxClick($event: Event): void {
        if ($event.currentTarget === this.elementRef.nativeElement) {
            $event.stopPropagation();
        }
    }

    constructor(
        public elementRef: ElementRef,
    ) { }

    ngOnInit(): void {
        if (this._isFullScreenMobileModal()) {
            this._bodyScrollLock(true);
        } else {
            this._bodyScrollLock(false);
        }
    }

    ngAfterViewInit(): void {
        const activeElem: HTMLElement = document.activeElement as HTMLElement;
        if (activeElem && activeElem !== document.body && typeof activeElem.blur === 'function') {
            activeElem.blur();
        }
    }

    ngOnDestroy(): void {
        this._bodyScrollLock(false);
    }

    private _isFullScreenMobileModal(): boolean {
        return this.mobilePreserve === false && window.innerWidth < 768;
    }

    private _bodyScrollLock(lock: boolean): void {
        if (lock) {
            document.body.style.height = '100vh';
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.height = null;
            document.body.style.overflow = null;
        }
    }

    public get feel(): State.MODAL_FEEL {
        return this.modalData.feel || null;
    }
}
